import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../../elements/button'
import Icon from '../../../../components/icons'
import { useUserSelector } from '../../../../store/selectors/userSelector'
import { isBuisenessOwnerRepectToExperiment, isMyExperiment } from '../../../../_common/functions'
import ExperimentCommentModal from '../../../../components/modal/ExperimentComment.modal'

type CommentButtonProps = {
    experiment: any
    className?: string
}

const CommentButton: React.FC<CommentButtonProps> = ({ experiment, className = '' }) => {
    const { t } = useTranslation()
    const user: any = useUserSelector()
    const [comments, setComments] = useState<any[]>([])
    const commentModalRef = useRef<any>(null)
    const openComment = () => {
        commentModalRef?.current?.showModal()
    }

    return (
        <>
            {isMyExperiment(experiment, user?.user_literal) && comments.length > 0 && (
                <Button className={className} theme="secondary" size="xxs" styleType="outline" onClick={openComment}>
                    <Icon name="note" size={1} />
                    {t('View Note')}
                </Button>
            )}

            {isBuisenessOwnerRepectToExperiment(experiment, user?.user_literal) && !isMyExperiment(experiment, user?.user_literal) && (
                <Button theme="secondary" size="xxs" styleType="outline" onClick={openComment} className={className}>
                    <Icon name="note" size={1} />
                    {t('Review Note')}
                </Button>
            )}

            <ExperimentCommentModal
                success={() => {
                    commentModalRef?.current?.close()
                }}
                _ref={commentModalRef}
                updateComments={setComments}
            />
        </>
    )
}
export default CommentButton
